import React, { FC } from 'react';

import clx from 'classnames';
import { Channel } from 'client/model/skill';

import styles from './AppCardPicture.module.scss';

interface Props {
    channel: Channel;
    screenshotUrl?: string;
    logoUrl?: string;
}

export const AppCardPicture: FC<Props> = ({ channel, screenshotUrl, logoUrl }) => {
    if (logoUrl && (channel === Channel.AliceSkill || channel === Channel.SmartHome)) {
        return (
            <div className={styles.skillIconPreview__container}>
                <img className={styles.skillIconPreview__iconShadow} src={logoUrl} alt={'icon shadow'} />
                <img className={styles.skillIconPreview__image} src={logoUrl} alt={'skill icon'} />
            </div>
        );
    }

    if (!screenshotUrl) return null;

    if (channel === Channel.TvApp)
        return (
            <div className={clx(styles.screenshotBlock__container, styles.screenshotBlock__container_tv)}>
                <div className={styles.screenshotBlock__shadow}></div>
                <div
                    className={clx(styles.screenshotBlock__image, styles.screenshotBlock__image_tv)}
                    style={{ backgroundImage: `url(${screenshotUrl})` }}
                ></div>
                <img
                    className={clx(styles.screenshotBlock__border, styles.screenshotBlock__border_tv)}
                    src={
                        'https://avatars.mds.yandex.net/get-dialogs/1644703/screenshot-tv-empty-border/catalogue-banner-x1'
                    }
                    alt="empty-tv-border"
                />
            </div>
        );
    if (channel === Channel.SmartScreenApp)
        return (
            <div className={clx(styles.screenshotBlock__container, styles.screenshotBlock__container_smartScreen)}>
                <div className={styles.screenshotBlock__shadow}></div>
                <div
                    className={clx(styles.screenshotBlock__image, styles.screenshotBlock__image_smartScreen)}
                    style={{ backgroundImage: `url(${screenshotUrl})` }}
                ></div>
                <img
                    className={clx(styles.screenshotBlock__border, styles.screenshotBlock__border_smartScreen)}
                    src={
                        'https://avatars.mds.yandex.net/get-dialogs/399212/screenshot-device-with-screen-empty-border/catalogue-banner-x1'
                    }
                    alt="empty-smartScreen-border"
                />
            </div>
        );
    if (channel === Channel.AutoApp)
        return (
            <div className={clx(styles.screenshotBlock__container, styles.screenshotBlock__container_auto)}>
                <div className={styles.screenshotBlock__shadow_auto}></div>
                <div
                    className={clx(styles.screenshotBlock__image, styles.screenshotBlock__image_auto)}
                    style={{ backgroundImage: `url(${screenshotUrl})` }}
                ></div>
                <img
                    className={clx(styles.screenshotBlock__border, styles.screenshotBlock__border_auto)}
                    src={
                        'https://avatars.mds.yandex.net/get-dialogs/399212/screenshot-device-with-screen-empty-border/catalogue-banner-x2'
                    }
                    alt="empty-smartScreen-border"
                />
            </div>
        );
    return null;
};
